import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export const StoreHeader = () => {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();
  const accountPath = user && user.role === "admin" ? "/admin" : "/account";

  return (
    <header className="sticky top-0 z-40 bg-black/70 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo-mark.png" alt="Vinci" className="h-7 w-auto" />
          <span className="font-serif text-xl tracking-tight">Vinci Inc.</span>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <Link to="/shop" data-testid="store-nav-shop" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Shop</Link>
          <Link to="/request-quote" data-testid="store-nav-quote" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Request a Quote</Link>
          <Link to="/trends" data-testid="store-nav-trends" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Price Trends</Link>
          <Link to="/brands" data-testid="store-nav-brands" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Brands</Link>
          <Link to="/network" data-testid="store-nav-network" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Network</Link>
          <Link to="/leadership" data-testid="store-nav-leadership" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Leadership</Link>
          <Link to="/" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Home</Link>
          {user ? (
            <Link to={accountPath} className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">{user.role === "admin" ? "Trade Desk" : "Account"}</Link>
          ) : (
            <Link to="/login" className="font-grotesk text-xs uppercase tracking-[0.2em] text-[#C9C9C2] hover:text-[#F5F5F0] transition-colors">Sign in</Link>
          )}
        </nav>
        <button data-testid="cart-button" onClick={() => setOpen(true)} className="relative grid place-items-center w-11 h-11 rounded-full border border-white/20 hover:border-[#B87333] transition-colors">
          <ShoppingBag size={18} />
          {count > 0 && (
            <span data-testid="cart-count" className="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 grid place-items-center rounded-full bg-[#B87333] text-black font-grotesk text-[10px] font-bold">{count}</span>
          )}
        </button>
      </div>
    </header>
  );
};
